import React from "react";
import Settings from "./settings/Settings";
import Reports from "./reports/Reports";
import Inbound from "./inbound/Inbound";
import Billing from "./billing/Billing";
import Sharing from "./sharing/Sharing";
import OrdersTab from "./orders/OrdersTab";
import CatalogTab from "./catalog/CatalogTab";

export default function ProjectTabs({ selected, onClose, onChange }) {
  let activeTab = selected;
  if (["outbound", "internal"].includes(selected)) activeTab = "orders";
  if (["sku_library", "kitting", "grouped_items"].includes(selected)) activeTab = "catalog";

  switch (activeTab) {
    case "settings":
      return <Settings onClose={onClose} />;
    case "sharing":
      return <Sharing onClose={onClose} />;
    case "reports":
      return <Reports onClose={onClose} />;
    case "inbound":
      return <Inbound onClose={onClose} />;
    case "billing":
      return <Billing onClose={onClose} />;
    case "orders":
      return <OrdersTab onClose={onClose} activeView={selected} onChange={onChange} />;
    case "catalog":
      return <CatalogTab onClose={onClose} activeView={selected} onChange={onChange} />;
    default:
      return null;
  }
}
